module.exports = __webpack_public_path__ + "img/img (12).2a31f58b.png";